<ng-container *ngIf="holidayAtHome$ | async | ready; else pickHolidayDate">
  <app-holiday-mode-select *ngIf="!selectedHolidayType; else pickHolidayDate" (cancelSettingHolidayProgram)="onCancel()"
    (submitSelectedHolidayType)="goToNextStage($event)"></app-holiday-mode-select>
</ng-container>
<ng-template #pickHolidayDate>
  <app-holiday-mode-datepicker [data]="data"
    [isHolidayAtHome]="selectedHolidayType === holidayProgramType.HOLIDAY_AT_HOME"
    (cancelSettingHolidayProgram)="onCancel()" (submitHolidayProgram)="onSubmit($event)"></app-holiday-mode-datepicker>
</ng-template>
